/**
 * Visual emphasis for the work-order create mileage field (#2114).
 *
 * Mileage is the most important hand-entered value on this step, but it must
 * not block Next. The field is highlighted when empty or when the entered
 * reading is lower than the latest recorded; both are hints, not validation.
 *
 * Non-numeric input is not reachable from the TextField (digits only), but
 * this helper still refuses NaN-based comparisons so a bad string cannot be
 * treated as lower-than-latest.
 */

export type MileageEmphasis =
  | { kind: 'missing' }
  | { kind: 'lowerThanLatest'; latest: number }
  | { kind: 'ok' };

export function resolveMileageEmphasis(
  mileageInput: string,
  latestMileage: number | null | undefined,
): MileageEmphasis {
  if (mileageInput.trim() === '') {
    return { kind: 'missing' };
  }

  const entered = Number(mileageInput);
  if (!Number.isFinite(entered)) {
    return { kind: 'ok' };
  }

  if (latestMileage == null || !Number.isFinite(latestMileage)) {
    return { kind: 'ok' };
  }

  if (entered < latestMileage) {
    return { kind: 'lowerThanLatest', latest: latestMileage };
  }

  return { kind: 'ok' };
}
